import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function lengthValidator(minLength: number, maxLength: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null; // If the field is empty, don't validate
    }
    const valueLength = control.value.length;
    if (valueLength < minLength || valueLength > maxLength) {
      return { lengthError: { requiredMinLength: minLength, requiredMaxLength: maxLength } };
    }
    return null; // Validation passed
  };
}
